export const language = {
  en: {
    "Select Supplier": "Select Supplier",
    "Supplier Company Code": "Supplier Company Code",
    "Supplier Name": "Supplier Name",
    Query: "Query",
    Ok: "Ok",
    "Import and Export Documents": 'Import and Export Documents',
     
  },
  zh: {
    "Select Supplier": "选择供应商",
    "Supplier Company Code": "供应商编号",
    "Supplier Name": "供应商名称",
    Query: "查询",
    Ok: "确认",
    "Import and Export Documents": '进出口单据服务',
    
  },
};
  